import React from 'react';
import Faq from '../../../../public/Icons/toolTip.svg';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const ToolTipContent = ({ label, isBottom }) => {
    return (
        <>
            <OverlayTrigger placement={isBottom ? "bottom" : "top"} overlay={<Popover className='imageUploadTooltipContainer'>{label}</Popover>}>
                <img src={Faq} />
            </OverlayTrigger>
        </>
    )
}

export default ToolTipContent;
